import { Controller } from "@hotwired/stimulus"

// Disables a work block option in every other select that shares the same work category
// (e.g. two estilos pointing at the same categoría).
export default class extends Controller {
  connect() {
    this.syncDisabledOptions()
  }

  sync() {
    this.syncDisabledOptions()
  }

  syncDisabledOptions() {
    const selects = Array.from(this.element.querySelectorAll("select[data-category-id]"))
    const byCategory = {}
    selects.forEach((sel) => {
      const id = sel.dataset.categoryId
      if (!id) return
      if (!byCategory[id]) byCategory[id] = []
      byCategory[id].push(sel)
    })

    Object.values(byCategory).forEach((group) => {
      group.forEach((sel) => {
        Array.from(sel.options).forEach((opt) => {
          if (opt.value !== "") opt.disabled = false
        })
      })

      if (group.length < 2) return

      group.forEach((sel) => {
        const takenElsewhere = new Set()
        group.forEach((other) => {
          if (other !== sel && other.value) takenElsewhere.add(other.value)
        })
        Array.from(sel.options).forEach((opt) => {
          if (opt.value === "") return
          opt.disabled = takenElsewhere.has(opt.value)
        })
      })

      group.forEach((sel) => {
        const v = sel.value
        if (!v) return
        const opt = Array.from(sel.options).find((o) => o.value === v)
        if (opt?.disabled) sel.selectedIndex = 0
      })
    })
  }
}
